import styled from "styled-components";
interface ButtonProps {
  children: string;
  width: string;
  height: string;
  active: string;
  size: string;
  func: any;
}

export default function Button({
  children,
  active,
  width,
  height,
  size,
  func,
}: ButtonProps) {
  return (
    <ButtonSt
      onClick={(e) => func(e)}
      w={width}
      h={height}
      size={size}
      active={active === children}
    >
      {children}
    </ButtonSt>
  );
}

export const ButtonSt = styled.button<{
  w: string;
  h: string;
  size: string;
  active: boolean;
}>`
  background-color: ${({ active }) => (active ? "#ffb000" : "transparent")};
  color: ${({ active }) => (active ? "#6168af" : "#ffb000")};
  border: 3px solid #ffb000;
  border-radius: 50px;
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  font-size: ${({ size }) => size};
  cursor: ${({ active }) => (active ? "auto" : "pointer")};
`;
